import {Component, Input, OnInit} from '@angular/core';
import {HttpService} from '../../services/apiServices/http-service.service';
import {TranslateService} from '@ngx-translate/core';
import {AsynchronousRequest} from '../../services/apiServices/asynchronous-request';
import {CommonService} from '../../services/apiServices/business/common.service';


/**
 * Only display a loader with a configurable message
 */
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  /**
   * The message that'll be displayed within the loader
   */
  @Input('waitingMessage')
  public waitingMessage: string;

  /**
   * The request that is currently processed by httpService
   */
  public activeRequest: AsynchronousRequest;

  /**
   * the number of pending request in httpService
   */
  private sizeOfQueue: number;

  /**
   * The title of message displayed when the user click on 'cancel'
   */
  private cancelTitle;

  /**
   * The message displayed when the user click on 'cancel'
   */
  private cancelMessage;

  /**
   * default constructor, handle various services
   * @param {HttpService} httpService - handle request interruption
   * @param commonService
   * @param {TranslateService} translate - handle cancel message translation
   */
  constructor(private httpService: HttpService, private commonService: CommonService, private translate: TranslateService) {
    this.getTradForComponent();
  }

  /**
   * handle subscriptions
   */
  public ngOnInit(): void {
    this.getTradForComponent();
    this.httpService.activeRequest.subscribe(activeRequest => {
      this.activeRequest = activeRequest;
    });
    this.httpService.pendingToProcess.subscribe(result => {
      this.sizeOfQueue = result;
    });
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('TOASTER.CANCEL_OPERATION_TITLE').subscribe((res: string) => {
      this.cancelTitle = res;
    });
    this.translate.get('TOASTER.CANCEL_OPERATION_Message').subscribe((res: string) => {
      this.cancelMessage = res;
    });
  }

  /**
   * called when the user click on cancel button, warn http service to stop the active request and display a message
   */
  public cancel(): void {
    this.httpService.cancelledRequest.push(this.activeRequest.id);
    this.httpService.pendingToProcess.next(this.sizeOfQueue - 1);

    this.commonService.addToast({life: 3000,
      severity: 'warn',
      summary: this.cancelTitle,
      detail: this.cancelMessage
    });
  }


}
